import { sample } from 'effector'
import { matchPath } from 'react-router'

import { Pages } from '@/consts/routes.ts'
import { $creatorId } from '@/models/creators.ts'
import { initializeApp } from '@/models/init.ts'
import { $currentPage } from '@/models/router.ts'
import {
  addScriptsCategoryFx,
  deleteScriptsCategoryFx,
  editScriptsCategoryFx,
  moveScriptsCategoryFx,
} from '@/models/scripts/categories.ts'
import {
  addScriptFx,
  deleteScriptFx,
  editScriptFx,
  getScriptsFx,
  importScriptsFx,
  moveScriptFx,
} from '@/models/scripts/scripts.ts'

sample({
  clock: [
    addScriptsCategoryFx.doneData,
    editScriptsCategoryFx.doneData,
    deleteScriptsCategoryFx.doneData,
    moveScriptsCategoryFx.doneData,
    addScriptFx.doneData,
    editScriptFx.doneData,
    deleteScriptFx.doneData,
    moveScriptFx.doneData,
    importScriptsFx.doneData,
  ],
  target: getScriptsFx,
})

// trigger scripts request
sample({
  clock: [$currentPage, $creatorId, initializeApp],
  source: {
    page: $currentPage,
    creatorId: $creatorId,
  },
  // if creator id exists, and we are at the chatting ui or at scripts settings
  filter: ({ creatorId, page }) =>
    !!creatorId &&
    (!!matchPath(Pages.CHATTING_UI, page) ||
      !!matchPath(Pages.CREATOR_SCRIPTS, page)),
  target: getScriptsFx,
})
